/* global deptProcListUsersUrl deptProcFetchUrl deptProcFaceFetchItemsUrl deptProcFetchItemUrl deptProcExpensesUrl */
/* global deptProcStoreItemUrl deptProcSyncProjectsUrl deptProcStorePRUrl deptProcIndexPRUrl deptProcCreatePOUrl */
/* global deptProcDirectPurchaseOrderUrl deptProcDirectCommitmentUrl deptProcDownloadAttachmentUrl */
/* global deptProcPrEnabled deptProcEaEnabled deptProcDirectCommitEnabled deptContextId */
/* global currencySymbol eventStartDate eventEndDate */

import React from 'react';
import ReactDOM from 'react-dom';

import App from 'App';

import ProcurementProvider from '../context/ProcurementProvider';

import DeptPlanTab from './DeptPlanTab';

import { ConfirmationModalProvider } from 'Context/ConfirmationModalContext';
import { UsersProvider } from 'Context/UsersContext';

/**
 * IB-702 — department-scoped Procurement "face". Mounts the trimmed IB-700 Plan tab (Plan + Gantt)
 * for a single department, fed by the dept-scoped globals declared in departments/procurement-plan
 * .blade.php. Rendered only when the ProcurementRedesign flag is on (the blade branches on it).
 */
if (document.getElementById('deptProcurementFace')) {
    var root = document.getElementById('deptProcurementFace');

    ReactDOM.render(
        <App>
            <ConfirmationModalProvider>
                <UsersProvider fetchUrl={deptProcListUsersUrl}>
                    <ProcurementProvider
                        // settings
                        isPrEnabled={deptProcPrEnabled}
                        isEaEnabled={deptProcEaEnabled}
                        isDirectCommitEnabled={deptProcDirectCommitEnabled}
                        currencySymbol={currencySymbol}
                        eventStartDate={eventStartDate}
                        eventEndDate={eventEndDate}
                        departmentContextId={deptContextId}
                        // Routes
                        fetchProcurementPlanUrl={deptProcFetchUrl}
                        fetchProcurementPlanItemsUrl={deptProcFaceFetchItemsUrl}
                        fetchProcurementPlanItemUrl={deptProcFetchItemUrl}
                        fetchExpensesUrl={deptProcExpensesUrl}
                        storeProcurementPlanItemUrl={deptProcStoreItemUrl}
                        syncProcurementPlanProjectsUrl={deptProcSyncProjectsUrl}
                        storePRUrl={deptProcStorePRUrl}
                        indexPRUrl={deptProcIndexPRUrl}
                        createPurchaseOrderUrl={deptProcCreatePOUrl}
                        directPurchaseOrderUrl={deptProcDirectPurchaseOrderUrl}
                        directCommitmentUrl={deptProcDirectCommitmentUrl}
                        downloadProcurementPlanItemAttachmentUrl={deptProcDownloadAttachmentUrl}
                    >
                        <DeptPlanTab />
                    </ProcurementProvider>
                </UsersProvider>
            </ConfirmationModalProvider>
        </App>,
        root,
    );
}
